import * as React from 'react'

import Menu from '@mui/material/Menu'
import IconButton from '@mui/material/IconButton'
import MoreVert from '@mui/icons-material/MoreVert'

import type { Params } from '../typings'
import { EditButton } from './EditButton'
import { DeleteButton } from './DeleteButton'
import { useData, useHandlers } from './hooks'
import { GridValidRowModel } from '@mui/x-data-grid-pro'
import { useActivityData } from '@user/features/Activity/hooks'

export function ActionMenu(props: Params<GridValidRowModel>) {
  const { id, row } = props

  const { open, anchorEl, disabled, setAnchorEl } = useData()

  const { onOpen, onClose } = useHandlers({ setAnchorEl })

  const { updateDeleteEnabled } = useActivityData({ activity: row })
  if (!updateDeleteEnabled) return null
  return (
    <>
      <IconButton
        size="small"
        onClick={onOpen}
        disabled={disabled}
        data-test-id={`activitySummary-menu-${id}`}
      >
        <MoreVert fontSize="small" />
      </IconButton>

      <Menu open={open} onClose={onClose} anchorEl={anchorEl}>
        <EditButton params={props} onClose={onClose} disabled={disabled} />
        <DeleteButton params={props} onClose={onClose} disabled={disabled} />
      </Menu>
    </>
  )
}
